import Link from "next/link";
import { UrlObject } from "url";
import { Stack } from "@chakra-ui/react";
import { FiArrowUpRight } from "@onemind-services-llc/react-icons-ng/fi";
import { SimpleList, SimpleListProps } from "../list";
import { Text, Button } from "@/elements";

type ContentProps = {
  link?: string | UrlObject;
  text?: string;
} & SimpleListProps;

export const ContentCard = (props: ContentProps) => {
  const { link, text, points } = props;
  const textVariant = "body2";

  return (
    <Stack height={"100%"} justifyContent={link ? "space-between" : "start"} gap={4}>
      {text && (
        <Text color={"text.100"} variant={textVariant} whiteSpace={"pre-line"}>
          {text}
        </Text>
      )}
      {points && <SimpleList points={points} />}
      {link && (
        <Button
          as={Link}
          cursor={"pointer"}
          href={link}
          variant={"link"}
          color="primary.200"
          _groupHover={{ backgroundColor: "white" }}
          w={"fit-content"}
          px={3}
          py={1.5}
        >
          <Text fontWeight={600} variant={textVariant}>
            Explore more
          </Text>
          <FiArrowUpRight fontSize={"24px"} />
        </Button>
      )}
    </Stack>
  );
};
